import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { CircularProgress } from '#src/atoms/loader/CircularProgress/index.tsx';
import { LabelL, LabelS } from '#src/atoms/typography/index.tsx';

const StyledProgress = styled(CircularProgress)`
  width: var(--double-unit);
  --circular-progress-stroke: var(--c-onBase-success);
`;

type Props = { ownedCards: number; totalCards: number };

export const CardsNumber = ({ ownedCards, totalCards }: Props) => {
  return (
    <Horizontal center>
      <StyledProgress maxProgress={totalCards} progress={ownedCards} />
      <span>
        <LabelL bold as="span">
          {ownedCards}
        </LabelL>
        <LabelS as="span" color="var(--c-nd-700)">
          /{totalCards}
        </LabelS>
      </span>
    </Horizontal>
  );
};
